var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * CheckThick component
 */
export class BlocksIconCheckThick extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4092 0.00520891C18.077 0.0464377 17.7674 0.199983 17.5451 0.433826C17.5121 0.468534
          14.9238 3.59687 11.7933 7.38568C8.66286 11.1745 6.0955 14.2809 6.08806 14.2888C6.07522 14.3025 5.98503 14.1881 4.2998 12.0206C2.72632
          9.99676 2.51408 9.72702 2.42818 9.6419C2.21626 9.43188 1.96984 9.30428 1.66943 9.249C1.57323 9.23129 1.3781 9.22571 1.26996 9.23756C0.567643
          9.31453 0.0277086 9.89611 0.00148956 10.6039C-0.00434311 10.7613 0.00641813 10.866 0.0432784 11.0101C0.0846751 11.1719 0.141162 11.301
          0.228828 11.4341C0.281482 11.5141 3.92276 16.1994 4.00628 16.2947C4.36951 16.709 4.85876 17.0085 5.39565 17.1452C5.6123 17.2003 5.77347
          17.2222 6.00773 17.2282C6.66964 17.2453 7.29903 17.0279 7.82301 16.601C8.03492 16.4284 7.78673 16.7255 13.9337 9.28586C17.1199 5.42969
          19.7374 2.25494 19.765 2.21305C19.9334 1.95826 20.0104 1.68102 19.9989 1.37082C19.9811 0.891711 19.7317 0.464342 19.3207 0.20864C19.1777
          0.11971 18.9866 0.0469977 18.8172 0.0170822C18.7274 0.0012324 18.4956 -0.00551232 18.4092 0.00520891Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconCheckThick.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCheckThick.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconCheckThick.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconCheckThick.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-check-thick') === undefined) {
    customElements.define('cat-icon-check-thick', BlocksIconCheckThick);
}
